import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './global-loading.scss';
import React from 'react';
var GlobalLoading = function GlobalLoading(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'position-fixed' : _ref$className;
  return /*#__PURE__*/React.createElement("div", {
    className: "card bg-light global-loading text-center border ".concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    className: "my-2",
    spin: true
  }), /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled text-muted"
  }, /*#__PURE__*/React.createElement("li", null, "Loading"), /*#__PURE__*/React.createElement("li", null, "\u52A0\u8F7D\u4E2D"), /*#__PURE__*/React.createElement("li", null, "\u8AAD\u307F\u8FBC\u307F\u4E2D"), /*#__PURE__*/React.createElement("li", null, "\uBD88\uB7EC\uC624\uB294 \uC911"), /*#__PURE__*/React.createElement("li", null, "Carregando"), /*#__PURE__*/React.createElement("li", null, "Cargando"))));
};
export default GlobalLoading;